const SESSION_EXPIRED_EVENT = "dashboard:session-expired";

let sessionExpiredEmitted = false;

export const emitSessionExpired = () => {
  if (sessionExpiredEmitted) {
    return;
  }

  sessionExpiredEmitted = true;
  globalThis.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
};

export const resetSessionExpired = () => {
  sessionExpiredEmitted = false;
};

export const subscribeToSessionExpired = (listener: () => void) => {
  globalThis.addEventListener(SESSION_EXPIRED_EVENT, listener);

  return () => {
    globalThis.removeEventListener(SESSION_EXPIRED_EVENT, listener);
  };
};
